import axios from 'axios';
import store from '@/store'; // para disparar logout em 401

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 30000,
});

// REQUEST: só seta header se token existir
api.interceptors.request.use(config => {
    const token = window.localStorage.getItem('@donativa/token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        delete config.headers.Authorization;
    }
    // ajuda a evitar cache em alguns proxies
    config.headers['Cache-Control'] = 'no-cache';
    config.headers.Pragma = 'no-cache';
    return config;
});

// RESPONSE: qualquer 401 => logout imediato
api.interceptors.response.use(
    res => res,
    async error => {
        if (error?.response?.status === 401) {
            await store.dispatch('auth/logout');
            return; // interrompe a cadeia
        }
        return Promise.reject(error);
    },
);

export default api;
